import React, { useState, useEffect, useMemo, useRef } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Table from "../../Components/PropertiesNew/InventoryTable";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import BedStatus from "../../Components/AddTenant/BedStatus";
import SummaryCards from "../../Components/PropertiesNew/SummaryCard";
import AddTenantPage from "../../Components/AddTenant/AddTenantPage";
import SelectPackage from "../../Components/Room/SelectPackage";
import EditPackage from "../../Components/Room/EditPackage";
import EditRoom from "../../Components/Room/EditRoom";
import { toast } from "react-toastify";
import EditFlat from "../../Components/Room/EditFlat";
import AddRoomNumber from "../../Components/Room/AddRoomNumber";
import { SummarySkeletonLoading } from "../../Components/SkeletonLoading";
import AddExtraBed from "../../Components/Room/AddExtraBed";
import DeleteExtraBed from "../../Components/Room/DeleteExtraBed";
import { useLocation, useNavigate } from "react-router-dom";
import { IoFilter } from "react-icons/io5";
import SideModal from "../../Components/SideModal";
import AddMultipleTenantPage from "../../Components/AddMultipleTenant/AddMultipleTenantPage";
import useTenantDetailsModal from "../../utilities/useTenantDetailsModal";
import TenantDetailsModal from "../../Components/Tenants/TenantDetailsModal";
import usePaymentReminder from "../../utilities/usePaymentReminder";
import PaymentLinkModal from "../../Components/PaymentLinkModal";
import FilterModal from "../../Components/Properties/VacancyReport/FilterModal";
import PropertyListSidebar from "../../Components/PropertiesNew/Sidebar";
import { FiArrowLeft } from "react-icons/fi";
import BedHistory from "../../Components/Flats/BedHistory";

const ViewBeds = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedSideFilter, setSelectedSideFilter] = useState(null);
  const [activeFilters, setActiveFilters] = useState({
    tenantPreference: null,
    amenities: [],
    roomSharing: null,
    vacancyType: null
    // dormant: false,
  });
  const location = useLocation();
  const navigate = useNavigate();
  const propertyDetails = location.state?.propertyDetails;
  const properties = location.state?.properties;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [addBed, setAddBed] = useState(false);
  const [addTenant, setAddTenant] = useState(false);
  const [addMultipleTenant, setAddMultipleTenant] = useState(false);
  const [editPackage, setEditPackage] = useState(false);
  const [selectedData, setSelectedData] = useState();
  const [packageData, setPackageData] = useState();
  const [editModel, setEditModel] = useState(false);
  const [flatModel, setFlatModel] = useState(false);
  const [roomNumberModel, setRoomNumberModel] = useState(false);
  const [isCreatingNew, setIsCreatingNew] = useState(false);
  const [selectedFloor, setSelectedFloor] = useState(null);
  const [filteredRooms, setFilteredRooms] = useState([]);
  const [propData, setPropData] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [isExtraBed, setIsExtraBed] = useState(false);
  const [isExtraBedDelete, setIsExtraBedDelete] = useState(false);
  const [summary, setSummary] = useState(null);
  const btnRef = useRef(null);
  const [selectedProperty, setSelectedProperty] = useState(
    propertyDetails || null
  );
  const [isBedActionModalOpen, setIsBedActionModalOpen] = useState(false);
  const [holdBedCount, setHoldBedCount] = useState(0);
  const handlePropertySelect = (property) => {
    setSelectedProperty(property);
    setSelectedFloor(null);
    setSelectedFilter(null);
    setSelectedSideFilter(null);
    setActiveFilters({
      tenantPreference: null,
      amenities: [],
      roomSharing: null,
      vacancyType: null
    });
    //setPropertyDropdownOpen(false);
    //setPropertySearch("");
  };

  const currentPropId = selectedProperty?.id || 0;
  const isFlat = selectedProperty?.type === 2;
  const [hasActiveFilters, setHasActiveFilters] = useState(false);
  const [isBedHistory, setIsBedHistory] = useState(false);
  const query = isFlat
    ? `/room/list-for-flat/client/${currentPropId}`
    : `/room/list/client/${currentPropId}`;

  const fetchFunction = async () => {
    const response = await axios.get(`${Config.apiUrl}${query}`, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.data === false) {
      return;
    } else {
      const allRooms = isFlat
        ? res?.data?.flats?.flatMap((flat) =>
          flat.rooms.map((room) => ({
            ...room,
            gender: flat?.gender || 3,
          }))
        ) || []
        : res?.data?.floors?.flatMap((floor) => floor.rooms) || [];

      setSummary(res?.stats);
      setRooms(allRooms);
      setPropData(isFlat ? res?.data?.flats : res?.data?.floors);
      setFilteredRooms(allRooms);
    }
  };
  const getError = (res) => { };

  const {
    isLoading: isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
    refetch,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    if (currentPropId === 0) {
      navigate("/property-list");
      return;
    }
    setSelectedFloor(null);
    getListMutate();
  }, [currentPropId, navigate]);

  const propStatus = data?.data?.property?.status;

  const applyAllFilters = (roomsToFilter, floorSelection, filters) => {
    if (!roomsToFilter.length) {
      if (floorSelection) {
        return [floorSelection];
      }
      return [];
    }

    let filtered = [...roomsToFilter];

    if (floorSelection) {
      if (floorSelection.floor !== undefined) {
        filtered = filtered.filter((room) => room.floor == floorSelection.floor);
      } else {
        filtered = filtered.filter((room) => room.flatId == floorSelection.id);
      }
    }

    if (filtered.length === 0 && floorSelection) {
      return [floorSelection];
    }

    if (filters.tenantPreference !== null && filters.tenantPreference !== 3) {
      filtered = filtered.map(room => {
        const beds = Array.isArray(room.beds) ? room.beds : [];

        const filteredBeds = beds.filter(bed => {
          const occupancies = Array.isArray(bed.occupancies) ? bed.occupancies : [];

          if (occupancies.length === 0) {
            return false;
          }
          return occupancies.some(occupancy =>
            occupancy.tenantGender === filters.tenantPreference
          );
        });

        if (filteredBeds.length > 0) {
          return {
            ...room,
            beds: filteredBeds
          };
        }
        return null;
      }).filter(room => room !== null);
    }

    if (filters.amenities.length > 0) {
      filtered = filtered.filter(room => {
        if (!room.amenities) return false;
        const roomAmenities = room.amenities.split(',').map(a => a.trim());
        return filters.amenities.every(amenity =>
          roomAmenities.includes(amenity)
        );
      });
    }

    if (filters.roomSharing !== null) {
      filtered = filtered.filter(room => {
        const beds = Array.isArray(room.beds) ? room.beds : [];
        const totalBeds = room.totalBedCount || beds.length || 0;
        const sharingValue = filters.roomSharing;
        if (sharingValue === "3+") {
          return totalBeds >= 3;
        }
        return totalBeds === sharingValue;
      });
    }

    // Vacancy Type filter
    if (filters.vacancyType !== null) {
      filtered = filtered
        .map((room) => {
          const beds = Array.isArray(room?.beds) ? room.beds : [];

          if (beds.length === 0) {
            return null;
          }

          // Fully Vacant
          if (filters.vacancyType === "1") {
            const vacantBeds = beds.filter(
              (bed) => Number(bed?.status) === Config.BED_STATUS.VACANT
            );

            // Every bed must be vacant
            if (vacantBeds.length === beds.length) {
              return {
                ...room,
                beds: vacantBeds,
              };
            }

            return null;
          }

          // Partial Vacant
          if (filters.vacancyType === "0") {
            const vacantBeds = beds.filter(
              (bed) => Number(bed?.status) === Config.BED_STATUS.VACANT
            );

            // Some vacant + some non-vacant
            if (
              vacantBeds.length > 0 &&
              vacantBeds.length < beds.length
            ) {
              return {
                ...room,
                beds: vacantBeds,
              };
            }

            return null;
          }

          // Dormant
          if (filters.vacancyType === "2") {
            const dormantBeds = beds.filter(
              (bed) => Number(bed?.isDormantInventory) === 1
            );

            if (dormantBeds.length > 0) {
              return {
                ...room,
                beds: dormantBeds,
              };
            }

            return null;
          }

          return room;
        })
        .filter(Boolean);
    }
    return filtered;
  };

  useEffect(() => {
    if (!rooms.length) {
      if (selectedFloor) {
        setFilteredRooms([selectedFloor]);
      } else {
        setFilteredRooms([]);
      }
      const hasAnyFilter = activeFilters.tenantPreference !== null ||
        activeFilters.amenities.length > 0 ||
        activeFilters.roomSharing !== null
        || activeFilters.vacancyType !== null;
      setHasActiveFilters(hasAnyFilter);
      return;
    }

    const filtered = applyAllFilters(rooms, selectedFloor, activeFilters);
    setFilteredRooms(filtered);

    const hasAnyFilter = activeFilters.tenantPreference !== null ||
      activeFilters.amenities.length > 0 ||
      activeFilters.roomSharing !== null
      || activeFilters.vacancyType !== null;
    setHasActiveFilters(hasAnyFilter);

  }, [activeFilters, rooms, selectedFloor]);
  // useEffect(() => {
  //   if (selectedFilter === "DORMANT") {
  //     setActiveFilters((prev) =>
  //       prev.dormant ? prev : { ...prev, dormant: true }
  //     );
  //   } else {
  //     setActiveFilters((prev) =>
  //       prev.dormant ? { ...prev, dormant: false } : prev
  //     );
  //   }
  // }, [selectedFilter]);

  const handleFloorSelect = (selection) => {
    setSelectedFloor(selection);
  };

  const handleAddPackageClose = () => {
    setAddBed(false);
    setIsCreatingNew(false);
  };
  const handleEditPackageClose = () => {
    setEditPackage(false);
  };

  const tenantRows = useMemo(() => {
    return (
      filteredRooms?.flatMap((room) => {
        const beds = Array.isArray(room?.beds)
          ? room.beds
          : [];

        return beds.flatMap((bed) => {
          const occupancies = Array.isArray(
            bed?.occupancies
          )
            ? bed.occupancies
            : [];

          return occupancies.map(
            (occupancy) => ({
              ...occupancy,
              room,
              bed,
            })
          );
        });
      }) || []
    );
  }, [filteredRooms]);

  const {
    selectedTenant,
    showTenantModal,
    openTenantModal,
    closeTenantModal,
    handleNext,
    handlePrevious,
    hasNext,
    hasPrevious,
    isLoading: isTenantDetailsLoading
  } = useTenantDetailsModal({
    tenants: tenantRows || [],
    token: user.token,
  });

  const {
    loadingId,
    paymentData,
    showPaymentLinkModal,
    loadPaymentLinkModal,
    closePaymentModal,
  } = usePaymentReminder(user.token);

  //------- Create Opion Bed -------
  const addOptionFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/room/option/create`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };
  const onAddOptionSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setAddBed(true);
      setIsCreatingNew(false);
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onAddOptionError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addOptionLoading, mutate: addOptionMutate } = useMutation(
    addOptionFunction,
    {
      onSuccess: onAddOptionSuccess,
      onError: onAddOptionError,
    }
  );

  //------- Select Opion Bed -------
  const selectOptionFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/room/beds/add`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };
  const onSelectOptionSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setAddBed(false);
      setIsCreatingNew(false);
      getListMutate();
      setSelectedFloor(null)
      // setSelectedFloor((prev) => ({ ...prev }));
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onSelectOptionError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addSelectLoading, mutate: addSelectMutate } = useMutation(
    selectOptionFunction,
    {
      onSuccess: onSelectOptionSuccess,
      onError: onSelectOptionError,
    }
  );

  //------- Edit Opion Bed -------
  const EditOptionFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/room/option/update`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };
  const onEditOptionSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setEditPackage(false);
      setAddBed(true);
      setIsCreatingNew(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onEditOptionError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: editOptionLoading, mutate: editOptionMutate } =
    useMutation(EditOptionFunction, {
      onSuccess: onEditOptionSuccess,
      onError: onEditOptionError,
    });

  //------- Edit Room Number -------
  const EditRoomNumberFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/room/edit`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };
  const onEditRoomNumberSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setEditModel(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onEditRoomNumberError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: editRoomNumberLoading, mutate: editRoomNumberMutate } =
    useMutation(EditRoomNumberFunction, {
      onSuccess: onEditRoomNumberSuccess,
      onError: onEditRoomNumberError,
    });

  //------- Deactivate Room  -------
  const DeactivateRoomFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/room/status/deactivate`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onRoomDeactivateSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setEditModel(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onRoomDeactivateError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: deactivateRoomLoading, mutate: deactivateRoomMutate } =
    useMutation(DeactivateRoomFunction, {
      onSuccess: onRoomDeactivateSuccess,
      onError: onRoomDeactivateError,
    });

  //------- Activate Room  -------
  const ActivateRoomFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/room/status/activate`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };
  const onRoomActivateSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setEditModel(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onRoomActivateError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: activateRoomLoading, mutate: activateRoomMutate } =
    useMutation(ActivateRoomFunction, {
      onSuccess: onRoomActivateSuccess,
      onError: onRoomActivateError,
    });

  //------- Edit Flat Number -------
  const EditFlatNumberFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/flat/name/update`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };
  const onEditFlatNumberSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setFlatModel(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onEditFlatNumberError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: editFlatNumberLoading, mutate: editFlatNumberMutate } =
    useMutation(EditFlatNumberFunction, {
      onSuccess: onEditFlatNumberSuccess,
      onError: onEditFlatNumberError,
    });

  //------- Deactivate Flat  -------
  const DeactivateFlatFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/flat/status/deactivate`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };
  const onFlatDeactivateSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setFlatModel(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onFlatDeactivateError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: deactivateFlatLoading, mutate: deactivateFlatMutate } =
    useMutation(DeactivateFlatFunction, {
      onSuccess: onFlatDeactivateSuccess,
      onError: onFlatDeactivateError,
    });

  //------- Activate Flat  -------
  const ActivateFlatFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/flat/status/activate`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };
  const onFlatActivateSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setFlatModel(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onFlatActivateError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: activateFlatLoading, mutate: activateFlatMutate } =
    useMutation(ActivateFlatFunction, {
      onSuccess: onFlatActivateSuccess,
      onError: onFlatActivateError,
    });

  // Add Room
  const apiRoomUrl = isFlat
    ? `${Config.apiUrl}/room/add-for-flat`
    : `${Config.apiUrl}/room/add`;

  const AddRoomFunction = async (values) => {
    return await axios.post(apiRoomUrl, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };
  const onAddRoomSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setRoomNumberModel(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onAddRoomError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addRoomNumberLoading, mutate: addRoomNumberMutate } =
    useMutation(AddRoomFunction, {
      onSuccess: onAddRoomSuccess,
      onError: onAddRoomError,
    });

  //------- Activate Property -------
  const ActivateFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/property/status/activate`,
      values,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/json",
        },
      }
    );
  };
  const onActivateSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onActivateError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
    getListMutate();
  };

  const { isLoading: activateLoading, mutate: activateMutate } = useMutation(
    ActivateFunction,
    {
      onSuccess: onActivateSuccess,
      onError: onActivateError,
    }
  );

  //------- Deactivate Property -------
  const DeactivateFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/property/status/deactivate`,
      values,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/json",
        },
      }
    );
  };

  const onDeactivateSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onDeactivateError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
    getListMutate();
  };

  const { isLoading: DeactivateLoading, mutate: deactivateMutate } =
    useMutation(DeactivateFunction, {
      onSuccess: onDeactivateSuccess,
      onError: onDeactivateError,
    });

  //------- Extra Bed Add -------
  const addExtraBedFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/room/extra-bed/add`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onExtraBedSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsExtraBed(false);
      //refetch();
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onExtraBedError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addExtraBedLoading, mutate: addExtraBedMutate } =
    useMutation(addExtraBedFunction, {
      onSuccess: onExtraBedSuccess,
      onError: onExtraBedError,
    });

  //------- Extra Bed Delete -------
  const deleteExtraBedFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/room/extra-bed/remove`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };
  const onExtraBedDeleteSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsExtraBedDelete(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onExtraBedDeleteError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: deleteExtraBedLoading, mutate: deleteExtraBedMutate } =
    useMutation(deleteExtraBedFunction, {
      onSuccess: onExtraBedDeleteSuccess,
      onError: onExtraBedDeleteError,
    });

  const statusOptions = {
    3: { label: "Active", options: [{ value: 4, label: "Inactive" }] },
    2: { label: "Completed", options: [{ value: 3, label: "Active" }] },
    4: { label: "Inactive", options: [{ value: 3, label: "Active" }] },
  };

  const handleClearFilter = () => {
    setSelectedFilter(null);
    setSelectedId(null);
    setSelectedFloor(null);
    setActiveFilters({
      tenantPreference: null,
      amenities: [],
      roomSharing: null,
      vacancyType: null
      // dormant: false,
    });
  };

  const handleRefresh = () => {
    getListMutate();
  };


  //------- Update Tenant Preference (Gender) for Flat -------
  const updateTenantPrefFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/flat/update/gender`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };
  const onUpdateTenantPrefSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setFlatModel(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onUpdateTenantPrefError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: updateTenantPrefLoading, mutate: updateTenantPrefMutate } =
    useMutation(updateTenantPrefFunction, {
      onSuccess: onUpdateTenantPrefSuccess,
      onError: onUpdateTenantPrefError,
    });

  // const onApplyFilter = (value, label, type) => {
  //   setActiveFilters(prevFilters => {
  //     const newFilters = { ...prevFilters };

  //     if (type === 1) {
  //       // Gender preference
  //       newFilters.tenantPreference = Number(value);
  //     } else if (type === 2) {
  //       if (!newFilters.amenities.includes(value)) {
  //         newFilters.amenities = [...newFilters.amenities, value];
  //       }
  //     } else if (type === 3) {
  //       // Room sharing
  //       newFilters.roomSharing = value === "4" ? "3+" : Number(value);
  //     }
  //     setIsFilterOpen(false);
  //     setSelectedFloor(null);
  //     return newFilters;
  //   });

  // };
  const onApplyFilter = (filtersToApply) => {
    const newFilters = {
      tenantPreference: null,
      amenities: [],
      roomSharing: null,
      vacancyType: null
      // dormant: false,
    };

    filtersToApply.forEach((filter) => {
      if (filter.type === 1) {
        newFilters.tenantPreference = Number(filter.value);
      }

      if (filter.type === 2) {
        newFilters.amenities.push(filter.value);
      }

      if (filter.type === 3) {
        newFilters.roomSharing =
          filter.value === "4" ? "3+" : Number(filter.value);
      }
      if (filter.type === 4) {
        newFilters.vacancyType = String(filter.value);
      }
      // if (filter.type === 4) {
      //   if (filter.value === "2") {
      //     newFilters.dormant = true;
      //   }
      // }
    });

    setActiveFilters(newFilters);
    setIsFilterOpen(false);
    setSelectedFloor(null);
    setSelectedFilter(newFilters.dormant ? "DORMANT" : null);
    setSelectedId(null);
  };

  const handleFilterClose = () => {
    setIsFilterOpen(false);
    setSelectedId(null);
    setSelectedFloor(null);
    setActiveFilters({
      tenantPreference: null,
      amenities: [],
      roomSharing: null,
      vacancyType: null
      // dormant: false,
    });
  };

  // Hold/UnHold Bed Functions
  const holdUnholdBedFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/room/hold/bed`,
      values,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/json",
        },
      }
    );
  };

  const onHoldUnholdBedSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsBedActionModalOpen(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onHoldUnholdBedError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading: holdUnholdBedLoading,
    mutate: holdUnholdBedMutate,
  } = useMutation(holdUnholdBedFunction, {
    onSuccess: onHoldUnholdBedSuccess,
    onError: onHoldUnholdBedError,
  });

  // End Hold/UnHold Bed Functions


  return selectedProperty && currentPropId !== 0 ? (
    <>
      {isModalOpen && <BedStatus setIsModalOpen={setIsModalOpen} />}

      <SideModal
        isOpen={addBed}
        onClose={() => setAddBed(false)}
      >
        <SelectPackage
          setAddTenant={setAddBed}
          addBed={addBed}
          handleClose={handleAddPackageClose}
          setEditPackage={setEditPackage}
          setPackageData={setPackageData}
          addOptionLoading={addOptionLoading}
          addOptionMutate={addOptionMutate}
          setIsCreatingNew={setIsCreatingNew}
          isCreatingNew={isCreatingNew}
          selectedData={selectedData}
          addSelectLoading={addSelectLoading}
          addSelectMutate={addSelectMutate}
          propId={currentPropId}
          security={selectedProperty?.security || 0}
        />
      </SideModal>

      <SideModal
        isOpen={editPackage}
        onClose={() => setEditPackage(false)}
      >
        <EditPackage
          setEditPackage={setEditPackage}
          editPackage={editPackage}
          handleClose={handleEditPackageClose}
          packageData={packageData}
          editOptionLoading={editOptionLoading}
          editOptionMutate={editOptionMutate}
        />
      </SideModal>

      <SideModal
        isOpen={addTenant}
        onClose={() => setAddTenant(false)}
      >
        <AddTenantPage
          setAddTenant={setAddTenant}
          addTenant={addTenant}
          selectedData={selectedData}
          getListMutate={getListMutate}
          propId={currentPropId}
          handleRefresh={handleRefresh}
          route="viewBeds"
        />
      </SideModal>

      <SideModal
        isOpen={addMultipleTenant}
        onClose={() => setAddMultipleTenant(false)}
      >
        <AddMultipleTenantPage
          setAddMultipleTenant={setAddMultipleTenant}
          addMultipleTenant={addMultipleTenant}
          selectedData={selectedData}
          getListMutate={getListMutate}
          propId={currentPropId}
          handleRefresh={handleRefresh}
          route="viewBeds"
        />
      </SideModal>

      {showTenantModal && (
        <SideModal
          isOpen={showTenantModal}
          onClose={closeTenantModal}
        >
          <TenantDetailsModal
            isLoading={isTenantDetailsLoading}
            tenant={selectedTenant}
            onClose={closeTenantModal}
            onNext={handleNext}
            onPrevious={handlePrevious}
            hasNext={hasNext}
            hasPrevious={hasPrevious}
            loadPaymentLinkModal={
              loadPaymentLinkModal
            }
            loadingId={loadingId}
          />
        </SideModal>
      )}

      <PaymentLinkModal
        isOpen={showPaymentLinkModal}
        onClose={closePaymentModal}
        paymentData={paymentData}
      />

      {editModel && (
        <EditRoom
          setEditModel={setEditModel}
          selectedData={selectedData}
          editRoomNumberLoading={editRoomNumberLoading}
          editRoomNumberMutate={editRoomNumberMutate}
          activateRoomLoading={activateRoomLoading}
          activateRoomMutate={activateRoomMutate}
          deactivateRoomLoading={deactivateRoomLoading}
          deactivateRoomMutate={deactivateRoomMutate}
          setIsExtraBed={setIsExtraBed}
          setSelectedData={setSelectedData}
        />
      )}

      {isExtraBed && (
        <AddExtraBed
          setIsExtraBed={setIsExtraBed}
          selectedData={selectedData}
          addExtraBedLoading={addExtraBedLoading}
          addExtraBedMutate={addExtraBedMutate}
        />
      )}

      {isExtraBedDelete && (
        <DeleteExtraBed
          setIsExtraBedDelete={setIsExtraBedDelete}
          selectedData={selectedData}
          deleteExtraBedLoading={deleteExtraBedLoading}
          deleteExtraBedMutate={deleteExtraBedMutate}
        />
      )}

      {flatModel && (
        <EditFlat
          setFlatModel={setFlatModel}
          selectedData={selectedData}
          editFlatNumberLoading={editFlatNumberLoading}
          editFlatNumberMutate={editFlatNumberMutate}
          activateFlatLoading={activateFlatLoading}
          activateFlatMutate={activateFlatMutate}
          deactivateFlatLoading={deactivateFlatLoading}
          deactivateFlatMutate={deactivateFlatMutate}
          updateTenantPrefMutate={updateTenantPrefMutate}
          updateTenantPrefLoading={updateTenantPrefLoading}
        />
      )}

      {roomNumberModel && (
        <AddRoomNumber
          setRoomNumberModel={setRoomNumberModel}
          selectedData={selectedData}
          addRoomNumberLoading={addRoomNumberLoading}
          addRoomNumberMutate={addRoomNumberMutate}
          propId={currentPropId}
          isFlat={isFlat}
        />
      )}
      {isBedHistory && (
        <SideModal
          isOpen={isBedHistory}
          onClose={() => setIsBedHistory(false)}
        >
          <BedHistory
            selectedData={selectedData}
            handleClose={() => setIsBedHistory(false)}
          />
        </SideModal>
      )}
      <BoxContainer>
        <BoxHead className="flex items-center justify-between">
          <BoxTitle className="!mb-0 whitespace-nowrap">
            Property Inventory
            <Underline />
          </BoxTitle>

          <button
            type="button"
            //onClick={() => navigate("/property-list")}
            onClick={() => navigate(-1)}
            className="flex items-center gap-1.5 text-primary-color text-sm
      font-medium hover:opacity-80 transition-opacity"
          >
            <FiArrowLeft size={18} />
            Back
          </button>
        </BoxHead>

        <div className="grid grid-cols-1 lg:grid-cols-[250px_minmax(0,1fr)] gap-4 py-2">
          {/* LEFT: compact property selector */}
          <PropertyListSidebar
            properties={properties}
            //loading={propertyListLoading}
            selectedProperty={selectedProperty}
            onSelect={handlePropertySelect}
          />

          {/* RIGHT: inventory */}
          <div className="min-w-0">
            <SideModal isOpen={isFilterOpen} onClose={() => setIsFilterOpen(false)}>
              <FilterModal
                onApplyFilter={onApplyFilter}
                handleClose={handleFilterClose}
                setSelectedFilter={setSelectedFilter}
                selectedFilter={selectedSideFilter}
                activeFilters={activeFilters}
              />
            </SideModal>
            {(isLoading || isRefetching) && <SummarySkeletonLoading count={5} />}
            {!error && !isLoading && !isRefetching && summary && (
              <SummaryCards
                summaryData={summary}
                setSelectedFilter={setSelectedFilter}
                selectedFilter={selectedFilter}
                selectedId={selectedId}
                setSelectedId={setSelectedId}
                handleClearFilter={handleClearFilter}
                holdBedCount={holdBedCount}
              />
            )}
            {!error && !isLoading && data && (
              <div className="pb-12">
                <div className="grid grid-cols-12 bg-white my-4 rounded-md border-b">
                  <div className="col-span-11 overflow-x-auto">
                    <FloorTabs className="w-full">
                      <FloorTab
                        key="ALL"
                        onClick={() => handleFloorSelect(null)}
                        $active={!selectedFloor}
                      >
                        All Rooms
                      </FloorTab>
                      {isFlat
                        ? propData.map((floorData, index) => (
                          <FloorTab
                            key={index}
                            onClick={() => handleFloorSelect(floorData)}
                            $active={selectedFloor?.id == floorData.id}
                          >
                            Flat {floorData.name}
                          </FloorTab>
                        ))
                        : propData.map((floorData, index) => (
                          <FloorTab
                            key={index}
                            onClick={() => handleFloorSelect(floorData)}
                            $active={selectedFloor?.floor == floorData.floor}
                          >
                            {"Floor " + floorData.floor}
                          </FloorTab>
                        ))}
                    </FloorTabs>
                  </div>

                  <div className="col-span-1 flex items-center justify-center ml-1">
                    <div className="relative">
                      <FilterBtn
                        ref={btnRef}
                        type="button"
                        title="Category Filter"
                        onClick={() => setIsFilterOpen((v) => !v)}
                      >
                        <IoFilter size={14} color="#9CA3AF" />
                      </FilterBtn>
                      {/* Yellow dot when filter is applied */}
                      {hasActiveFilters && (
                        <span className="absolute -top-1 -right-1 w-3 h-3 bg-yellow-400 rounded-full"></span>
                      )}
                    </div>
                  </div>
                </div>

                {filteredRooms.length === 0 && !selectedFloor && !hasActiveFilters && (
                  <NoRoomsMessage>
                    <p className="text-lg font-medium text-gray-800">
                      Select a floor to add rooms
                    </p>
                    <p className="text-sm text-gray-500 mt-1">
                      Rooms can only be added under a specific floor.
                    </p>
                    <p className="text-xs text-gray-400 mt-3">
                      Choose a floor tab above to continue
                    </p>
                  </NoRoomsMessage>
                )}
                {filteredRooms.length === 0 && hasActiveFilters && (
                  <NoRoomsMessage>
                    <div className="flex flex-col items-center justify-center">
                      {/* <NotFoundModel /> */}
                      <p className="text-lg font-medium text-gray-800">
                        {hasActiveFilters ? "No rooms match your filters" : "No rooms found"}
                      </p>
                      <p className="text-sm text-gray-500 mt-2">
                        {hasActiveFilters
                          ? "Try adjusting your filter criteria or clear all filters"
                          : selectedFloor
                            ? "This floor has no rooms yet"
                            : "Select a floor to view rooms"}
                      </p>
                      {hasActiveFilters && (
                        <button
                          onClick={handleClearFilter}
                          className="mt-4 px-4 py-2 text-sm font-medium text-white bg-primary-color rounded-md hover:bg-primary-color-dark transition-colors"
                        >
                          Clear All Filters
                        </button>
                      )}
                    </div>
                  </NoRoomsMessage>
                )}
                {!error && !isLoading && filteredRooms.length > 0 && (
                  <TableWrapper className="border border-gray-200 rounded-lg overflow-hidden">
                    {/* <div className="px-4 py-3 bg-gray-50 border-b text-sm font-medium text-gray-700">
                  Rooms List
                </div> */}
                    <Table
                      apiData={error ? [] : filteredRooms}
                      isFlat={isFlat}
                      setAddBed={setAddBed}
                      setSelectedData={setSelectedData}
                      selectedData={selectedData}
                      setAddTenant={setAddTenant}
                      setAddMultipleTenant={setAddMultipleTenant}
                      setEditModel={setEditModel}
                      setFlatModel={setFlatModel}
                      setRoomNumberModel={setRoomNumberModel}
                      propStatus={propStatus}
                      selectedFilter={selectedFilter}
                      selectedFloor={selectedFloor}
                      setIsExtraBed={setIsExtraBed}
                      setIsExtraBedDelete={setIsExtraBedDelete}
                      handleOpenTenantModal={openTenantModal}
                      holdUnholdBedMutate={holdUnholdBedMutate}
                      holdUnholdBedLoading={holdUnholdBedLoading}
                      setIsBedActionModalOpen={setIsBedActionModalOpen}
                      isBedActionModalOpen={isBedActionModalOpen}
                      onHoldBedCountChange={setHoldBedCount}
                      setIsBedHistory={setIsBedHistory}
                    />
                    {error && !isLoading && <NotFoundModel />}
                  </TableWrapper>
                )}
              </div>
            )}
            {(isLoading || isRefetching) && <Loading />}
          </div>
        </div>
      </BoxContainer>
    </>
  ) : (
    <Loading />
  );
};

const FloorTabs = tw.div`flex overflow-x-auto`;
const FloorTab = tw.button`
  ${(p) =>
    p.$active
      ? " text-primary-color border-b-2 border-b-primary-color bg-cyan-50 "
      : " text-gray-700 "} 
   px-5 py-4  cursor-pointer font-medium transition-all duration-200 whitespace-nowrap text-sm
`;
const TableWrapper = tw.div`my-4 bg-white rounded-md`;
// const NoRoomsMessage = tw.div`
//     text-center text-lg font-semibold text-gray-700 bg-gray-100 p-4 rounded-md mt-4
// `;
const NoRoomsMessage = tw.div`
  text-center bg-gray-50 border border-dashed border-gray-300
  p-28 rounded-xl mt-4
`;
const FilterBtn = tw.button`flex items-center border whitespace-nowrap border-gray-300 justify-center rounded-md px-4 cursor-pointer bg-white hover:bg-gray-200 h-10 text-sm ml-auto`;

export default ViewBeds;
